import * as Fathom from "fathom-client";
import { CONFIG } from "@shared/config";

const {
  application: {
    initialization: {
      tracking: { fathomId },
    },
  },
} = CONFIG;

export const initFathom = (): void => {
  if (fathomId) {
    Fathom.load(fathomId);
  }
};
